export default __webpack_public_path__ + "static/media/D_content1.12a88609.png";